import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Shown after login when the user's role has no modules (roleModules empty).
@Component({
  selector: 'app-noaccess',
  templateUrl: './noaccess.component.html',
  styleUrls: ['./noaccess.component.scss']
})
export class NoAccessComponent implements OnInit {

  email: string = '';
  officeName: string = '';

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.email = sessionStorage.getItem('email') ?? '';
    const offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
    const myOffice = offices.find((o: any) => o.isMyoffice == true);
    this.officeName = myOffice ? (myOffice.officeName ?? '') : '';
  }

  signOut() {
    sessionStorage.clear();
    this.router.navigate(['/auth/login']);
  }
}
